var Flickity = require('flickity'),
	$ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null),
	dotdotdot = require('dotdotdot'),
	Typekit = (typeof window !== "undefined" ? window['Typekit'] : typeof global !== "undefined" ? global['Typekit'] : null);

function QuoteCarousel(el) {
	var t = this;
	t.primaryCarouselEl = el.querySelector('[data-primary-carousel]');
	t.sideCarouselEl = el.querySelector('[data-side-carousel]');
	t.current = el.querySelector('[data-carousel-current]');
	t.prev = el.querySelector('[data-carousel-prev]');
	t.next = el.querySelector('[data-carousel-next]');

	if (t.primaryCarouselEl && t.sideCarouselEl) {
		t.init();
	}

	$(el).find('.quote-carousel__description').dotdotdot({
		after: "span.quote-carousel__description-link",
    ellipsis: ''
	});

  loadReadMore();
  $(window).on('resize', loadReadMore);

	$(el).find('.quote-carousel__description-link').on('click', function() {
    $(this).closest('.quote-carousel__description').addClass('long-text').trigger('destroy');
    t.primaryCarousel.resize();
	});

  function loadReadMore() {
    var windowWidth = $(window).width(),
        $quoteDesc = $(el).find('.quote-carousel__description');

    t.primaryCarousel.resize();

    if( windowWidth < 450 ) {
      $quoteDesc.dotdotdot({
        after: "span.quote-carousel__description-link",
        ellipsis: ''
      });
    } else {
      $quoteDesc.trigger("destroy");
    }


  }

}

QuoteCarousel.prototype.init = function () {
	var t = this;

	$(window).on('load', function() {
		t.primaryCarousel.resize();
		t.sideCarousel.resize();
	});

	t.primaryCarousel = new Flickity(t.primaryCarouselEl, {
		prevNextButtons: false,
		pageDots: false,
		contain: true,
		adaptiveHeight: false,
		accessibility: false
	});

	t.sideCarousel = new Flickity(t.sideCarouselEl, {
		prevNextButtons: false,
		pageDots: false,
		contain: true,
		adaptiveHeight: true,
		accessibility: false
	});

	t.primaryCarousel.on('select', t.syncWith(t.primaryCarousel, t.sideCarousel).bind(t));
	t.sideCarousel.on('select', t.syncWith(t.sideCarousel, t.primaryCarousel).bind(t));

	if (t.prev) {
		t.prev.addEventListener('click', function() {
			t.primaryCarousel.previous();
		});
	}
	if (t.next) {
		t.next.addEventListener('click', function() {
			t.primaryCarousel.next();
		});
	}
};

QuoteCarousel.prototype.syncWith = function (fromCarousel, toCarousel) {
	var t = this;
	return function() {
		if (t.syncing) {
			t.syncing = false;
		} else {
			t.syncing = true;
			if (t.current) {
				t.current.textContent = fromCarousel.selectedIndex + 1;
			}
			toCarousel.select(fromCarousel.selectedIndex);
		}
	};
};

module.exports = QuoteCarousel;